const VALID_CODE = /^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/;

export function isValidDepartmentCode(value: string): boolean {
  return value.length >= 2 && value.length <= 64 && VALID_CODE.test(value);
}

export function suggestDepartmentCode(name: string): string {
  const ascii = name
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-+/g, "-");
  if (!ascii) return `dept-${stableDigest(name.trim() || "department")}`;
  const prefixed = /^[a-z]/.test(ascii) ? ascii : `dept-${ascii}`;
  const expanded = prefixed.length >= 2 ? prefixed : `dept-${prefixed}`;
  const bounded = expanded.slice(0, 64).replace(/-+$/g, "");
  return isValidDepartmentCode(bounded) ? bounded : `dept-${stableDigest(name)}`;
}

function stableDigest(value: string): string {
  let hash = 0x811c9dc5;
  for (const character of value.normalize("NFKC")) {
    hash ^= character.codePointAt(0) ?? 0;
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash.toString(16).padStart(8, "0");
}
